<template>
  <Repricing />
</template>
<script>
import Repricing from "@/components/shared/Repricing";
export default {
  components: {
    Repricing,
  },
  updated() {
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("tenant-job-browser-link");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/job/tenantJob/TenantJobRepricing.vue